import { RoomEvent, Room, NotificationCount } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { roomService } from '../roomService';
import { matrixClient } from '../../client';

const fileLogger = new Log(false, 'im.client.room.handlers.unread');
fileLogger.childrenPaused = true;
function onRoomUnreadNotifications(room: Room, notificationCounts: NotificationCount) {
    const logger = fileLogger.sub(false, 'onRoomUnreadNotifications');
    logger.pause = true;
    const roomId = room.roomId;
    logger.log(`Unread notifications in room ${room.name} (${roomId}):`, notificationCounts);

    // 更新未读计数
    const roomInfo = {
        roomId,
        name: room.name,  // 确保包含必需的 name 属性
        unreadCount: notificationCounts.total,
        highlightCount: notificationCounts.highlight
    };
    roomService.addOrUpdateRoomInfo(roomInfo);
}

export const unreadHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(
            RoomEvent.UnreadNotifications, 
            onRoomUnreadNotifications
        );
    }
};
